export const toPrice = (value: number, mark = ' ₽') =>
  `${Math.floor(value).toLocaleString()}${mark}`
